import {createRouter, createWebHistory} from 'vue-router';

import Home from './pages/HomePage.vue';
import Offer from './pages/OfferPage.vue';
import Shops from './pages/ShopsPage.vue';
import Jobs from './pages/JobsPage.vue';
import Contact from './pages/ContactPage.vue';
import NotFound from './pages/NotFoundPage.vue';
import Product from './pages/ProductPage.vue'
import PayLater from './pages/landingPages/PayLater.vue';
import Gastronomy from './pages/GastronomyPage.vue';
import Delivery from "./pages/DeliveryPage";
import WishesPage from "./pages/WishesPage.vue";

const router = createRouter({
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/app/offer',
            name: 'offer',
            component: Offer,
        },
        {
            path: '/app/product/:id?',
            name: 'product',
            component: Product,
            props: true
        },
        {
            path: '/app/shops/:id?',
            name: 'shops',
            component: Shops,
            props: true
        },
        {
            path: '/app/services',
            redirect: {name: 'home'},
        },
        {
            path: '/app/jobs',
            name: 'jobs',
            component: Jobs
        },
        {
            path: '/app/contact/:type?/:jobOfferId?/:jobOfferTitle?/:orderId?/:announcementId?',
            name: 'contact',
            component: Contact,
            props: true,
        },
        {
            path: '/:pathMatch(.*)*',
            name: '404',
            component: NotFound
        },
        {
            path: '/app/payLater',
            name: 'payLater',
            component: PayLater
        },
        {
            path: '/app/gastronomy',
            name: 'gastronomy',
            component: Gastronomy
        },
        {
            path: '/app/delivery',
            name: 'delivery',
            component: Delivery
        },
        {
            path: '/app/zyczenia',
            name: 'zyczenia',
            component: WishesPage
        },
    ]
});

export default router;
